import Steps, { Step } from 'rc-steps';
import 'rc-steps/assets/iconfont.css';
import 'rc-steps/assets/index.css';
import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
/*import HmAjax from '../../util/HmAjax';*/

const description = '';

class VerticalStepper extends LoggedInPage{
  constructor(props){
    super(props);
    this.state={
      dataLoaded:false,
      stepperData:props.steps,
      activeData: (!isNaN(props.currentStep)) ? props.currentStep : 0
    }

    this.steps = props.steps || null;
  }

  componentDidMount(){
    this.getRourceData()
  }



  getRourceData(){
      var me = this;
      me.setState({dataLoaded:true, activeData:this.props.currentStep});

      var callBackSuccess = function(response){
           me.setState({activeData:0,dataLoaded:true});			
      }

      var callBackFailure = function(response){
        console.error("response : ", response);
      }

		/// new HmAjax(this.getUrlFor("CONTEST_GET_USER_STATUS")).get(callBackSuccess,callBackSuccess);
  }

  renderStepperUI(){
    let defaultIcon = <i className="material-icons"></i>
    let ansicon = <i className="material-icons">done</i>
    
    if(this.state.stepperData){

      return(<Steps direction="vertical" current={(!isNaN(this.props.currentStep) && this.props.currentStep > 1) ? (this.props.currentStep-1) : this.state.activeData}>
            {
               this.state.stepperData.map((stepdata,index) => {
                return (
                  <Step key = {index} subTitle={stepdata} title={"Step "+(index+1)+":"} icon={ansicon} description={description} />
                )
              })
            }
         </Steps>
     ) 
  }
}

render(){
  if(!this.state.dataLoaded){
    return(
      <div>{this.showLoader()}</div>
    )
  }else{
    return(
      <div id="stepperlayout">
        <div className="headingtxt">
        {this.rb("RIPMWC.title")}
       </div>
        <div className="cont">
        {this.renderStepperUI()}
          </div>
      </div>
    )
  }
}

 
}

export default VerticalStepper;


// WEBPACK FOOTER //
// ./src/views/contest/VerticalLinearStepper.js